const PENDING_LOCATION_KEY = 'lagerverwaltung.pending-location';
const PENDING_DURATION_MS = 2 * 60 * 60 * 1000;

export function normalizeBaseLocation(value) {
  const match = String(value || '').trim().toUpperCase().match(/^DB-([A-Z])-(\d{1,2})$/);
  if (!match) return '';
  return `DB-${match[1]}-${match[2].padStart(2, '0')}`;
}

export function locationBaseFromPath() {
  const match = window.location.pathname.match(/^\/platz\/([^/]+)\/?$/i);
  return match ? normalizeBaseLocation(decodeURIComponent(match[1])) : '';
}

export function suggestLevel(boxes, baseCode) {
  const used = new Set(
    (boxes || [])
      .map(box => String(box.standort || '').toUpperCase().match(
        new RegExp(`^${baseCode.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}-E(\\d)$`)
      ))
      .filter(Boolean)
      .map(match => Number.parseInt(match[1], 10))
  );
  for (let level = 1; level <= 9; level += 1) {
    if (!used.has(level)) return level;
  }
  return 1;
}

export function savePendingLocation(baseCode, level) {
  const normalizedBase = normalizeBaseLocation(baseCode);
  const parsedLevel = Number.parseInt(level, 10);
  if (!normalizedBase || !Number.isInteger(parsedLevel) || parsedLevel < 1 || parsedLevel > 9) return;
  window.localStorage.setItem(PENDING_LOCATION_KEY, JSON.stringify({
    baseCode: normalizedBase,
    level: parsedLevel,
    expiresAt: Date.now() + PENDING_DURATION_MS,
  }));
}

export function loadPendingLocation() {
  try {
    const pending = JSON.parse(window.localStorage.getItem(PENDING_LOCATION_KEY));
    if (!pending || pending.expiresAt < Date.now()) {
      clearPendingLocation();
      return null;
    }
    const baseCode = normalizeBaseLocation(pending.baseCode);
    const level = Number.parseInt(pending.level, 10);
    if (!baseCode || !Number.isInteger(level) || level < 1 || level > 9) return null;
    return { baseCode, level };
  } catch {
    clearPendingLocation();
    return null;
  }
}

export function clearPendingLocation() {
  window.localStorage.removeItem(PENDING_LOCATION_KEY);
}
